import { Component, OnInit } from '@angular/core';
import liff from '@line/liff';
import { Router } from '@angular/router';
import { LiffService } from './liff.service';
import Swal from 'sweetalert2';
import { AuthenticationService } from 'src/app/core/service/authentication.service';
import { Subscription } from 'rxjs';
import { MenuItem } from 'primeng/api';
import { BaseInfo } from 'src/app/model/baseInfo.model';

@Component({
  selector: 'app-liff',
  templateUrl: './liff.component.html',
  styleUrls: ['./liff.component.css'],
})
export class LiffComponent implements OnInit {
  Liff_ID: string;
  CompanyID = '';
  avatarUrl: string = `assets/images/logo${this.CompanyID}.jpg`;
  defaultAvatar: string = 'assets/images/logo.jpg';
  UserID: string;
  IsMember: boolean = false;
  isOptionLoading: boolean = false;
  pageType: string; //可使用的功能(0:預約，1:會員)
  items: MenuItem[] | undefined;
  subscription: Subscription = new Subscription();
  model: BaseInfo;
  isRes: boolean = false;
  isBook: boolean = false;
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private LiffService: LiffService
  ) {}

  ngOnInit(): void {
    this.authenticationService.logout();

    //Liff清除快取處理
    setTimeout(()=>{
      localStorage.clear();
    },300);
    this.CompanyID = sessionStorage.getItem('CompanyID') ?? '';
    
    this.isOptionLoading = true;
    
      // /**測試用 */
      // this.CompanyID = "1121120006";
      // this.UserID = "Ub582c01692aeb469b49648934b38544f";
      this.setAvatarUrl();
      if (!!this.CompanyID) {
        //到後端取得LiffID
        this.GetLiffID();
      } else {
        Swal.fire({
          icon: 'error',
          title: '無法取得公司ID',
          text: '',
          footer: '',
        });
      }
    
  }
  setAvatarUrl() {
    this.avatarUrl = `assets/images/logo${this.CompanyID}.jpg`;
  }
  GetLiffID() {
    //取得LiffID
    var GetLiffID = this.LiffService.GetLiffID(this.CompanyID).subscribe(
      (data: any) => {
        if (!!data) {
          this.Liff_ID = data.LIFF_ID;
          
          // 此觸需加上權限清單來判斷可以使用功能
          this.items = this.buildMenu(data["LineInfo"]); 
          this.initializeLineLiff();
          //this.CheckUser();
        } else {
          Swal.fire({
            icon: 'error',
            title: '無法取得Liff_ID',
          });
        }
      }
    );
    this.subscription.add(GetLiffID);
  }

  initializeLineLiff() {
    liff
      .init({
        liffId: this.Liff_ID,
        withLoginOnExternalBrowser: true,
        //reset: true,
      })
      .then(() => {
        const BUSINESS_KEYS = [
          "user_info",
          "cart_cache",
          "step_cache",
        ];

        BUSINESS_KEYS.forEach(k => localStorage.removeItem(k));
      })
      .then(() => {
        //檢查使用者是否登入line
        if (!liff.isLoggedIn()) {
          liff.login();
          return;
        }
      })
      .then(() => {
        //需判斷: 只授權 LIFF 但是沒有加入官方帳號
        // if(this.IsFriend())
        // {
        //   try {
        //     //加入官方好友後，再判斷是否加入【官網會員】，藉由取得userID來判斷
        //     liff.getProfile()
        //     .then((profile) => {
        //       this.UserID = profile.userId;
        //       console.log("userID->",this.UserID);
        //       // const displayName = profile.displayName;
        //       // const pictureUrl = profile.pictureUrl;
        //       // const statusMessage = profile.statusMessage;
        //     })
        //     .catch((err) => {
        //       console.log("error", err);
        //     });
        //   } catch (error) {
        //     console.log("取得使用者基本資訊錯誤，訊息:"+error);
        //   }
        // }else{
        //   //導向加入官方帳號
        // }
        //加入官方好友後，再判斷是否加入【官網會員】，藉由取得userID來判斷
        liff
          .getProfile()
          .then((profile) => {
            this.UserID = profile.userId;

            this.CheckUser();
            // setTimeout(() => {
            //   this.isOptionLoading = false;
            // }, 800);
          })
          .catch((err) => {
            Swal.fire({
              icon: 'error',
              title: err,
            });
            liff.logout();

            Object.keys(localStorage)
              .filter(k => k.startsWith("liff_store_"))
              .forEach(k => localStorage.removeItem(k));

            liff.login({
              redirectUri: window.location.href
            });
          });
      })
      .catch((err) => {
        console.error(err.code, err.message);
      });
  }

  //確保用戶把官方帳號加為好友
  IsFriend() {
    var result = false;
    liff.getFriendship().then((data) => {
      if (data.friendFlag) {
        // You already have friendship with LINE Official Account
        result = true;
      } else {
        //還未加入官方帳號好友，連結到加入好友頁面
        console.log('還未加入官方帳號好友');
      }
    });
    return result;
  }

  CheckUser() {
    var CheckUser = this.LiffService.CheckUser(
      this.CompanyID,
      this.UserID
    ).subscribe((result: any) => {
      this.CheckSucceed(result);
    });
    this.subscription.add(CheckUser);
  }
  CheckSucceed(result: any) {
    if (!!result) {
      this.authenticationService.login(result);
      this.IsMember = true;
      this.model = result["otherInfo"];
      //顯示畫面
      this.isOptionLoading = false;
    } else {
      this.IsMember = false;
      this.router.navigate(['/register'], {
        queryParams: {
          CompanyID: this.CompanyID,
          UserID: this.UserID,
          Liff_ID: this.Liff_ID
        },
      });
    }
  }
  onImgError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = this.defaultAvatar;
  }
  goReserve() {
    if (!this.IsMember) {
      //前往註冊
      this.router.navigate(['/register'], {
        queryParams: {
          CompanyID: this.CompanyID,
          UserID: this.UserID,
          Liff_ID: this.Liff_ID,
          pageType: this.pageType,
          from: "reservation"
        },
      });
    } else {
      //前往預約
      this.router.navigate(['/reservation'], {
        queryParams: {
          CompanyID: this.CompanyID,
          UserID: this.UserID,
          Liff_ID: this.Liff_ID,
          pageType: this.pageType,
        },
      });
    }
  }

  goBook() {
    if (!this.IsMember) {
      //前往註冊
      this.router.navigate(['/register'], {
        queryParams: {
          CompanyID: this.CompanyID,
          UserID: this.UserID,
          Liff_ID: this.Liff_ID,
          pageType: this.pageType,
          from: "book"
        },
      });
    } else {
      //前往住宿
      this.router.navigate(['/book'], {
        queryParams: {
          CompanyID: this.CompanyID,
          UserID: this.UserID,
          Liff_ID: this.Liff_ID,
          pageType: this.pageType,
        },
      });
    }
  }
  buildMenu(res: string) {
    const menuMapping: any = {
      '0':{
        label: '預約資訊',
        svg: 'assets/images/calendar_month.svg',
        command: () => {
           this.router.navigate(['/searchRes'], {
              queryParams: {
                CompanyID: this.CompanyID,
                UserID: this.UserID,
                Liff_ID: this.Liff_ID
              },
            });
        }
      },  
      '1':{},//住宿
      '2':{
        label: '個人資料',
        svg: 'assets/images/person.svg',
        command: () => {
            this.router.navigate(['/member'], {
              queryParams: {
                CompanyID: this.CompanyID,
                UserID: this.UserID,
                Liff_ID: this.Liff_ID,
              },
            });
        }
      }, 
      '3':{
        label: '交易資訊',
        svg: 'assets/images/point_of_sale.svg',
        command: () => {
           this.router.navigate(['/tranhistory'], {
              queryParams: {
                CompanyID: this.CompanyID,
                UserID: this.UserID,
                Liff_ID: this.Liff_ID,
              },
            });
        }
      }, //交易履歷
      '4':{
        label: '剩餘點數',
        svg: 'assets/images/attach_money.svg',
        command: () => {
           this.router.navigate(['/balance'], {
              queryParams: {
                CompanyID: this.CompanyID,
                UserID: this.UserID,
                Liff_ID: this.Liff_ID,
              },
            });
        }
      }, //儲值餘額
      '5':{
        label: '包月資訊',
        svg: 'assets/images/health_and_beauty.svg',
        command: () => {
          this.router.navigate(['/memberSub'], {
              queryParams: {
                CompanyID: this.CompanyID,
                UserID: this.UserID,
                Liff_ID: this.Liff_ID,
              },
            });                 
        }
      }, //包月
      '6':{
        label: '同意書',
        svg: 'assets/images/contract_edit.svg',
        command: () => {
             this.router.navigate(['/consentForm'], {
              queryParams: {
                CompanyID: this.CompanyID,
                UserID: this.UserID,
                Liff_ID: this.Liff_ID,
              },
            });              
        }
      }, //同意書
    };

    const items: any[]=[];
    this.isRes = res == "1" || res == "3";
    this.isBook = res == "2" || res == "3";
    if(this.isRes||this.isBook ){
      items.push(menuMapping['0']);
    }
    // 把 API 回來的 ["1","2","5"] 轉成 menu model
    ['2','3','4','5','6'].forEach(e=>{
        items.push(menuMapping[e]);
    });
    return items;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
